import { bbanFormatter } from '@asn/formatters';

import { AfterViewInit, Component, input, ViewEncapsulation, inject } from '@angular/core';
import { NgControl, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApInputConstraintService } from '@ap/input/constraint';
import { ApContentService } from '@ap/content';
import { AbstractInputComponent, ApAutocompleteFilterService, ApAutocompleteModule } from '@ap/input';
import { ApMortgageValidator } from '@ap/input/validators';
import { ApSuggestionComponent } from '@ap/input/suggestion';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApIconComponent } from '@ap/icon';

import content from './mortgage-input.content.json';

@Component({
    selector: 'ap-mortgage-input',
    templateUrl: '../../../src/lib/input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, ApIconComponent, ApSuggestionComponent, ApFormErrorsComponent, ApAutocompleteModule, NgTemplateOutlet],
    providers: [ApInputConstraintService]
})
export class ApMortgageInputComponent extends AbstractInputComponent implements AfterViewInit {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);
    protected readonly filterService = inject(ApAutocompleteFilterService);

    /**
     * Maxlength of a mortgage is 14 (12.12.12.12.12)
     */
    protected readonly maxlength = input<number>(14);

    /**
     * Characters that are stripped
     */
    protected readonly stripPattern = input<RegExp>(/[^0-9.\s]/g);

    constructor() {
        super();
        this.setDefaultContent(content, 'mortgage-input');
    }

    /**
     * After init bind the control validation
     */
    public ngAfterViewInit(): void {
        const control = this.control?.control;
        if (control) {
            control.addValidators([ApMortgageValidator.validate]);
            control.updateValueAndValidity();
        }
    }

    /**
     * Format value as bban number
     * Called on blur of input
     */
    protected override formatValue(value: string): string {
        return bbanFormatter.format(value);
    }

    /**
     * Format mortgage number to human-readable string
     * @param {string} value
     * @returns {string}
     */
    protected override formatValueDisplay(value: string): string {
        return bbanFormatter.formatDisplay(value);
    }
}
